export default defineNuxtPlugin(() => {
    if (process.client) {
        let externalId = localStorage.getItem("external_id");

        if (!externalId) {
            externalId = `id_${Math.random().toString(36).substring(2, 9)}`;
            localStorage.setItem("external_id", externalId);
        }

        // Можно использовать в NuxtApp через $externalId, если нужно
        return {
            provide: {
                externalId,
            },
        };
    }
});
